<app-header />

@if (isLoading) {
  <div class="max-w-7xl mx-auto px-6 py-20 text-center">
    <p class="text-gray-600">Cargando...</p>
  </div>
} @else if (error || !event || !subevento) {
  <div class="max-w-7xl mx-auto px-6 py-20 text-center">
    <h2 class="text-2xl font-bold text-gray-800 mb-4">No se pudo cargar</h2>
    <p class="text-gray-600 mb-6">El recurso que buscas no está disponible.</p>
    <button
      (click)="goBackToEvent()"
      class="bg-[#e8343f] text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors"
    >
      Volver al inicio
    </button>
  </div>
} @else {

  <!-- Banner -->
  <section class="border-b border-gray-300">
    <div class="max-w-7xl mx-auto px-6 pt-2 pb-4">
      <div class="aspect-[40/21] bg-gray-100 border border-gray-300 overflow-hidden rounded-2xl relative">
        <img
          [src]="getBannerImage()"
          [alt]="subevento.nombre"
          class="w-full h-full object-cover"
        />
        <div class="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-8">
          <div>
            <!-- Breadcrumb -->
            <nav class="flex items-center text-white/80 text-sm mb-3 flex-wrap gap-1">
              <button (click)="goBackToEvent()" class="hover:text-white transition-colors">{{ event.nombre }}</button>
              <svg class="w-4 h-4 mx-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
              <button (click)="goBackToActividad()" class="hover:text-white transition-colors">{{ subevento.nombre }}</button>
              <svg class="w-4 h-4 mx-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
              <span class="text-white font-semibold">Comprar</span>
            </nav>
            <h1 class="text-3xl md:text-4xl font-bold text-white">{{ subevento.nombre }}</h1>
            <p class="text-white/90 mt-1 capitalize">{{ formatFecha(fecha) }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Contenido -->
  <section class="py-10">
    <div class="max-w-7xl mx-auto px-6">

      <!-- Navegación por niveles -->
      <div class="mb-8 space-y-4">
        <!-- Breadcrumb de pasos -->
        <div class="flex items-center gap-3 flex-wrap">
          <button
            (click)="goBackToActividad()"
            class="flex items-center gap-2 bg-[#e8343f] text-white px-5 py-3 rounded-xl text-base font-bold hover:bg-red-700 transition-colors shadow-md"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
            Cambiar fecha
          </button>

          @if (selectedHoraGroup) {
            <button
              (click)="deselectHoraGroup()"
              class="flex items-center gap-2 bg-[#e8343f] text-white px-5 py-3 rounded-xl text-base font-bold hover:bg-red-700 transition-colors shadow-md"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
              </svg>
              Cambiar horario
            </button>
          }
        </div>

        <!-- Resumen de selección actual -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div class="bg-white rounded-xl border-2 border-gray-200 p-5 flex items-center gap-4">
            <div class="bg-red-50 rounded-full w-14 h-14 flex items-center justify-center shrink-0">
              <svg class="w-7 h-7 text-[#e8343f]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
            </div>
            <div>
              <p class="text-sm text-gray-500">Fecha</p>
              <p class="text-xl font-bold text-gray-900 capitalize">{{ formatFecha(fecha) }}</p>
            </div>
          </div>
          @if (selectedHoraGroup) {
            <div class="bg-white rounded-xl border-2 border-[#e8343f] p-5 flex items-center gap-4">
              <div class="bg-red-50 rounded-full w-14 h-14 flex items-center justify-center shrink-0">
                <svg class="w-7 h-7 text-[#e8343f]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <div>
                <p class="text-sm text-gray-500">Horario</p>
                <p class="text-xl font-bold text-[#e8343f]">{{ selectedHoraGroup.hora }}</p>
              </div>
            </div>
          }
        </div>

        <!-- Título del paso actual -->
        <div class="flex items-center gap-3">
          <span class="bg-[#e8343f] text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold">{{ selectedHoraGroup ? '2' : '1' }}</span>
          <div>
            <h2 class="text-2xl font-bold text-gray-900">{{ selectedHoraGroup ? 'Selecciona tu coche' : 'Selecciona tu horario' }}</h2>
            <p class="text-gray-500 text-sm">{{ selectedHoraGroup ? 'Elige el tipo de coche para continuar.' : 'Elige el horario de la función.' }}</p>
          </div>
        </div>
      </div>

      @if (isLoadingTickets) {
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          @for (i of [1,2,3]; track i) {
            <div class="animate-pulse bg-gray-100 rounded-2xl h-52"></div>
          }
        </div>
      } @else if (horaGroups.length === 0) {
        <div class="text-center py-16 bg-gray-50 rounded-2xl border border-gray-200">
          <svg class="w-14 h-14 mx-auto mb-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          <p class="text-gray-500 text-lg">No hay funciones disponibles para esta fecha.</p>
          <button
            (click)="goBackToActividad()"
            class="mt-4 text-[#e8343f] font-medium hover:underline"
          >
            Seleccionar otra fecha
          </button>
        </div>
      } @else if (!selectedHoraGroup) {
        <!-- PASO 1: Lista de horarios -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          @for (group of horaGroups; track group.hora) {
            <div
              (click)="selectHoraGroup(group)"
              class="bg-white rounded-xl border-2 border-gray-200 p-6 cursor-pointer hover:border-[#e8343f] hover:shadow-lg transition-all flex items-center gap-4"
            >
              <div class="bg-red-50 rounded-full w-14 h-14 flex items-center justify-center shrink-0">
                <svg class="w-7 h-7 text-[#e8343f]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <div class="flex-1">
                <p class="text-xl font-bold text-gray-900">{{ group.hora }}</p>
                <p class="text-sm text-gray-500">{{ group.tiposTicket.length }} coche{{ group.tiposTicket.length !== 1 ? 's' : '' }} disponible{{ group.tiposTicket.length !== 1 ? 's' : '' }}</p>
              </div>
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </div>
          }
        </div>
      } @else {
        <!-- PASO 2: Vagones del horario seleccionado -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          @for (tt of selectedHoraGroup.tiposTicket; track tt.tipoticketid) {
            <div
              (click)="selectTipoTicket(tt)"
              [class.cursor-pointer]="getDisponibilidadEstado(tt) !== 'agotado'"
              [class.cursor-not-allowed]="getDisponibilidadEstado(tt) === 'agotado'"
              [class.opacity-60]="getDisponibilidadEstado(tt) === 'agotado'"
              class="bg-white rounded-xl border-2 border-gray-200 p-5 hover:border-[#e8343f] hover:shadow-lg transition-all"
            >
              <!-- Imagen del vagón -->
              <div class="flex justify-center mb-4">
                <img
                  [src]="getActividadImage()"
                  [alt]="tt.nombre_localidad"
                  class="w-full max-w-[120px] h-auto object-contain"
                />
              </div>

              <!-- Nombre -->
              <h4 class="text-xl font-bold text-gray-900 mb-1">{{ tt.nombre_localidad }}</h4>

              <!-- Estado disponibilidad -->
              @if (getDisponibilidadEstado(tt) === 'agotado') {
                <p class="text-red-600 font-semibold text-sm mb-3">Agotado</p>
              } @else if (getDisponibilidadEstado(tt) === 'limitado') {
                <p class="text-orange-600 font-semibold text-sm mb-3">
                  Solo quedan {{ getDisponiblesReales(tt) }} asientos
                </p>
              } @else {
                <p class="text-green-600 font-semibold text-sm mb-3">Disponible</p>
              }

              <!-- Barra de disponibilidad -->
              <div class="space-y-1 mb-4">
                <div class="flex justify-between text-xs text-gray-500">
                  <span>Disponibilidad</span>
                  <span>{{ getDisponiblesReales(tt) }} / {{ tt.aforo_maximo }}</span>
                </div>
                <div class="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                  <div
                    class="h-full rounded-full transition-all"
                    [class.bg-green-500]="getDisponibilidadEstado(tt) === 'disponible'"
                    [class.bg-orange-500]="getDisponibilidadEstado(tt) === 'limitado'"
                    [class.bg-red-500]="getDisponibilidadEstado(tt) === 'agotado'"
                    [style.width.%]="getDisponibilidadPorcentaje(tt)"
                  ></div>
                </div>
              </div>

              <!-- Precio -->
              @if (getPrecioDesde(tt) !== null) {
                <p class="text-sm text-gray-600">
                  Desde <span class="font-bold text-gray-900 text-base">${{ getPrecioDesde(tt)!.toFixed(2) }} {{ getMoneda(tt) }}</span>
                </p>
              }

              @if (getDisponibilidadEstado(tt) !== 'agotado') {
                <button class="mt-4 w-full bg-[#e8343f] text-white py-2 rounded-lg font-semibold hover:bg-red-700 transition-colors text-sm">
                  Seleccionar coche
                </button>
              }
            </div>
          }
        </div>
      }

    </div>
  </section>
}

<app-footer />
<app-scroll-to-top />
